import type { Rh_Attachment, Zrm_Attachment } from '../types/GraphqlTypes';

const STATUS_COMPLETE = 'complete';

type AttachmentStatus = Rh_Attachment['attachmentMetadataStatus'] | Zrm_Attachment['attachmentMetadataStatus'];
type AttachmentExpired = Rh_Attachment['isAttachmentExpired'] | Zrm_Attachment['isAttachmentExpired'];

export default (attachmentMetadataStatus: AttachmentStatus, isAttachmentExpired: AttachmentExpired) => {
  return attachmentMetadataStatus !== STATUS_COMPLETE && !isAttachmentExpired;
};
